import { createReducer, on, Action } from '@ngrx/store';
import { EntityState, createEntityAdapter, EntityAdapter } from '@ngrx/entity';
import * as FieldGroupActions from '../_actions/fieldGroup';
import { FieldGroup } from '../_models';

export interface FieldGroupState extends EntityState<FieldGroup> {
  loading: boolean;
  error: any;
}

export const adapter: EntityAdapter<FieldGroup> = createEntityAdapter<FieldGroup>({
  selectId: (fieldGroup: FieldGroup) =>
    fieldGroup.id !== null ? fieldGroup.id : Math.floor(Math.random() * -1000000),
});

const initialState: FieldGroupState = adapter.getInitialState({
  loading: false,
  error: null,
});

const FieldGroupReducer = createReducer(
  initialState,

  on(FieldGroupActions.loadFieldGroups, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),

  on(FieldGroupActions.loadFieldGroupsSuccess, (state, { fieldGroups }) =>
    adapter.setAll(fieldGroups, { ...state, loading: false })
  ),

  on(FieldGroupActions.loadFieldGroupsFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),

  on(FieldGroupActions.addFieldGroupSuccess, (state, { fieldGroup }) =>
    adapter.addOne(fieldGroup, state)
  ),

  on(FieldGroupActions.updateFieldGroupSuccess, (state, { fieldGroup }) =>
    adapter.upsertOne(fieldGroup, state)
  ),

  on(FieldGroupActions.deleteFieldGroupSuccess, (state, { id }) => adapter.removeOne(id, state)),

  on(
    FieldGroupActions.addFieldGroupFailure,
    FieldGroupActions.updateFieldGroupFailure,
    FieldGroupActions.deleteFieldGroupFailure,
    (state, { error }) => ({
      ...state,
      error,
    })
  )
);

export function reducer(state: FieldGroupState | undefined, action: Action) {
  return FieldGroupReducer(state, action);
}

export const { selectAll, selectEntities, selectTotal } = adapter.getSelectors();
